<script setup lang="ts">
import SceneWrapper from '@/sections/SceneWrapper.vue'
</script>

<template>
  <SceneWrapper></SceneWrapper>
</template>

<style scoped></style>